const zeroPaddedNumberString = (number: number): string => (number < 10 ? `0${number}` : number.toString());

export const formatDate = (date: Date): string => {
  // EventChunkUploader を受け取る ClipWorker は UTC に変換された時刻文字列を期待しているため、
  // 与えられた Date オブジェクトから getUTCHogehoge メソッドを通じて UTC に変換された時刻を取得し指定のフォーマットに揃える
  const year = date.getUTCFullYear();
  const month = zeroPaddedNumberString(date.getUTCMonth() + 1);
  const dates = zeroPaddedNumberString(date.getUTCDate());
  const hours = zeroPaddedNumberString(date.getUTCHours());
  const minutes = zeroPaddedNumberString(date.getUTCMinutes());
  const seconds = zeroPaddedNumberString(date.getUTCSeconds());
  // ミリ秒を3桁表示にするためのzero padding処理
  // 1 → 001, 11 → 011, 123 → 123
  const millisec = `000${date.getUTCMilliseconds()}`.slice(-3);

  return `${year}${month}${dates}${hours}${minutes}${seconds}${millisec}`;
};

// ブラウザ／端末の時刻がズレている可能性があるので、サーバからもらった responded_at の値を利用して各種時刻情報を調整するための関数
export const adjustDateWithOffset = (baseDate: Date, offsetMills: number): Date =>
  new Date(baseDate.getTime() - offsetMills);

// eventChunkデータを送る際にリクエストbodyをJSON.stringifyするが、このときに Date object は次のような文字列になってしまう
// JSON.stringify(new Date) => ""2018-11-27T11:02:56.756Z""
// UserProfileの値はClipWorkerを経由してcassandraに書き込まれるが、UserSegmentationのクエリとして利用される際にこのフォーマットだと
// TIMESTAMP型のデータとの比較ができず意図しない結果になってしまうので、Native SDKから送られているのと同じ "2018-11-27 11:02:56.756" というフォーマットに変換して記録する
export const formatISODate = (date: Date): string => date.toISOString().replace('T', ' ').replace('Z', '');
